const config = {
    name: 'Mapaya',
    DRAWER_WIDTH: 220,
};

const httpResponse = ({ status, message }) => ({ message: `${status} - ${message}`, status });

export { config, httpResponse };
